import { StateService, StateParams } from "@uirouter/angularjs";
import {CmdCenterEditOptionsModel} from "../../models/cmd/CmdCenterEditOptionsModel";

export class CmdCenterEditOptionsCtrl {
    public static $inject = ['$scope', '$state', '$stateParams', '$uibModal', 'CmdCenterEditOptionsModel'];
    constructor(public $scope:any, public stateService:StateService,
                public stateParamsService:StateParams, public modal:angular.ui.bootstrap.IModalService,
                public model:CmdCenterEditOptionsModel) {
        $scope.vm = this;
        this.model.init();
    }
}
